/* eslint-disable import/no-anonymous-default-export */
import PostAuditingToolReportActionTypes from './post-auditing-tool-report.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	getPostAuditingToolReportListResponse: null,
	getPostAuditingToolReportListArr: [],
	getPostAuditingToolReportExcelResponse: null,
	getPostAuditingToolReportExcelArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET POST AUDITING TOOL REPORT START *********************** */
		case PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_SUCCESS:
			return {
				...state,
				getPostAuditingToolReportListResponse: action.payload,
				getPostAuditingToolReportListArr: docodeHexResponse(
					action.payload,
					'GetPostAuditingToolReportKey',
				),
			};

		case PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_FAILURE:
			return { ...state, getPostAuditingToolReportListResponse: action.payload };

		case PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED:
			return { ...state, getPostAuditingToolReportListResponse: null };

		/** ***************** GET POST AUDITING TOOL REPORT END *********************** */

		/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS START *********************** */
		case PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_SUCCESS:
			return {
				...state,
				getPostAuditingToolReportExcelResponse: action.payload,
				getPostAuditingToolReportExcelArr: docodeHexResponse(
					action.payload,
					'PostAuditingToolReportExport',
				),
			};

		case PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_FAILURE:
			return { ...state, getPostAuditingToolReportExcelResponse: action.payload };

		case PostAuditingToolReportActionTypes.GET_POST_AUDITING_TOOL_REPORT_EXCEL_RESPONSE_CHANGED:
			return { ...state, getPostAuditingToolReportExcelResponse: null };

		/** ***************** FETCH POST AUDITING TOOL REPORT EXCEL DETAILS END *********************** */

		default:
			return state;
	}
};
